const _ = require('lodash');

module.exports = function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            options: '=',
            labelKey: '@?',
            selectedLabelKey: '@?',
            onChange: '&?',
            customSrMessage: '@?',
        },
        require: 'ngModel',
        link(scope, element, attrs, ngModel) {
            scope.labelKey = scope.labelKey || 'text';
            scope.selectedLabelKey = scope.selectedLabelKey || scope.labelKey;
            scope.srMessage = scope.customSrMessage ? scope.customSrMessage : 'selected, activate for more options';

            ngModel.$render = function () {
                scope.view = scope.renderOption(ngModel.$viewValue, scope.selectedLabelKey);
            };

            scope.renderOption = function (option, key) {
                const labelKey = key || scope.labelKey;
                return _.isObject(option)
                    ? option[labelKey]
                    : option;
            };

            const $dropdownElement = element.find('.olyDropdown');
            const $dropdownItemsContainer = element.find('.olyDropdown-items');
            let $dropdownItems = $dropdownItemsContainer.find('.olyDropdown-item');
            let currentIndex = 0;
            let isOpen = false;

            $dropdownItemsContainer[0].addEventListener('blur', () => {
                $timeout(() => {
                    if ($dropdownItemsContainer.has(document.activeElement).length === 0) {
                        // If the active document element is not one of the drop down items, we
                        // have tabbed out of the dropdown and so we close it.
                        $dropdownElement.removeClass('is-active');
                        isOpen = false;
                    }
                });
            }, true);

            scope.toggleDropdown = function ($event) {
                $event.stopPropagation();

                // Set focus on the first item in the list
                $timeout(() => {
                    $dropdownElement.toggleClass('is-active');
                    $dropdownElement.find('.olyDropdown-link:first').focus();
                    $dropdownItems = $dropdownItemsContainer.find('.olyDropdown-item');
                    currentIndex = 0;
                    isOpen = !isOpen;
                });
            };

            scope.selectOption = function (option) {
                $dropdownElement.removeClass('is-active');

                ngModel.$setViewValue(option);
                ngModel.$render();

                if (scope.onChange) {
                    scope.onChange({ option });
                }
            };

            scope.onKeyDown = function (event) {
                if (!isOpen) {
                    return true;
                }

                switch (event.keyCode) {
                    case 38: // UP
                        event.preventDefault();
                        if (currentIndex > 0) {
                            currentIndex--;
                            $dropdownItems.get(currentIndex).firstElementChild.focus();
                        }
                        return false;
                    case 40: // DOWN
                        event.preventDefault();
                        if (currentIndex < $dropdownItems.length - 1) {
                            currentIndex++;
                            $dropdownItems.get(currentIndex).firstElementChild.focus();
                        }
                        return false;
                    default:
                        return true;
                }
            };
        },
        template: require('./inline-dropdown.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/dropdown/inline-dropdown.directive.js